import { format } from "date-fns";
import { Loader2, Check, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

interface BookingItemProps {
  booking: any;
  onApprove: (id: string) => void;
  onReject: (id: string) => void;
  processingId: string | null;
}

export const BookingItem = ({ 
  booking, 
  onApprove, 
  onReject, 
  processingId 
}: BookingItemProps) => {
  return (
    <div className="flex items-center justify-between p-4 border rounded-lg">
      <div>
        <h3 className="font-medium">{booking.property?.title}</h3>
        <p className="text-sm text-muted-foreground">
          {booking.guest?.full_name} • {booking.guest?.phone_number}
        </p>
        <div className="flex gap-2 mt-1">
          <Badge variant="outline">
            {format(new Date(booking.check_in_date), 'MMM d')} - {format(new Date(booking.check_out_date), 'MMM d')}
          </Badge>
          <Badge variant="outline">
            ${Number(booking.total_price).toLocaleString()}
          </Badge>
        </div>
      </div>
      <div className="flex gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={() => onReject(booking.id)}
          disabled={processingId === booking.id}
        >
          {processingId === booking.id ? (
            <Loader2 className="h-4 w-4 animate-spin" />
          ) : (
            <X className="h-4 w-4" />
          )}
        </Button>
        <Button
          size="sm"
          onClick={() => onApprove(booking.id)}
          disabled={processingId === booking.id}
        >
          {processingId === booking.id ? (
            <Loader2 className="h-4 w-4 animate-spin" />
          ) : (
            <Check className="h-4 w-4" />
          )}
        </Button>
      </div>
    </div>
  );
};